import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container';
import { FaCamera } from 'react-icons/fa';

export const StoreConfigurationInfoComponent = ({ changeImage, onInnerFormChange, selectedStore }: any) => (
          <>

          <AccordionContainer
              child={
         


<div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer
          label="Color"
          labelField="Color"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.StoreBranding.Primary.Color',
              selectedStore?.Configurations?.StoreBranding?.Primary
            );
          }}
          type="text"
          value={selectedStore?.Configurations?.StoreBranding?.Primary?.Color}
      />
  <InputContainer
          label="BackgroundColor"
          labelField="BackgroundColor"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.StoreBranding.Primary.BackgroundColor',
              selectedStore?.Configurations?.StoreBranding?.Primary
            );
          }}
          type="text"
          value={selectedStore?.Configurations?.StoreBranding?.Primary?.BackgroundColor}
      />
    <InputContainer
          label="BackgroundImage"
          labelField="BackgroundImage"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.StoreBranding.Primary.BackgroundImage',
              selectedStore?.Configurations?.StoreBranding?.Primary
            );
          }}
          type="text"
          value={selectedStore?.Configurations?.StoreBranding?.Primary?.BackgroundImage}
      />
   </div>
  
}
              expandedPanel="Primary Info"
              headerTitle="Primary Info"
          />

     <AccordionContainer
         child={
    
<div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer
          label="Color"
          labelField="Color"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.StoreBranding.Secondary.Color',
              selectedStore?.Configurations?.StoreBranding?.Secondary
            );
          }}
          type="text"
          value={selectedStore?.Configurations?.StoreBranding?.Secondary?.Color}
      />
   <InputContainer
          label="BackgroundColor"
          labelField="BackgroundColor"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.StoreBranding.Secondary.BackgroundColor',
              selectedStore?.Configurations?.StoreBranding?.Secondary
            );
          }}
          type="text"
          value={selectedStore?.Configurations?.StoreBranding?.Secondary?.BackgroundColor}
      />
  <InputContainer
          label="BackgroundImage"
          labelField="BackgroundImage"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.StoreBranding.Secondary.BackgroundImage',
              selectedStore?.Configurations?.StoreBranding?.Secondary
            );
          }}
          type="text"
          value={selectedStore?.Configurations?.StoreBranding?.Secondary?.BackgroundImage}
      />
    </div>

}
         expandedPanel="Secondary Info"
         headerTitle="Secondary Info"
     />
      <AccordionContainer
          child={

<div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer
          label="Color"
          labelField="Color"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.StoreBranding.Tertiary.Color',
              selectedStore?.Configurations?.StoreBranding?.Tertiary
            );
          }}
          type="text"
          value={selectedStore?.Configurations?.StoreBranding?.Tertiary?.Color}
      />
   <InputContainer
          label="BackgroundColor"
          labelField="BackgroundColor"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.StoreBranding.Tertiary.BackgroundColor',
              selectedStore?.Configurations?.StoreBranding?.Tertiary
            );
          }}
          type="text"
          value={selectedStore?.Configurations?.StoreBranding?.Tertiary?.BackgroundColor}
      />
  <InputContainer
          label="BackgroundImage"
          labelField="BackgroundImage"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.StoreBranding.Tertiary.BackgroundImage',
              selectedStore?.Configurations?.StoreBranding?.Tertiary
            );
          }}
          type="text"
          value={selectedStore?.Configurations?.StoreBranding?.Tertiary?.BackgroundImage}
      />
    </div>

}
          expandedPanel="Tertiary Info"
          headerTitle="Tertiary Info"
      />
       <AccordionContainer
           child={
      
<div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
 <InputContainer
          label="Color"
          labelField="Color"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.StoreBranding.Ghost.Color',
              selectedStore?.Configurations?.StoreBranding?.Ghost
            );
          }}
          type="text"
          value={selectedStore?.Configurations?.StoreBranding?.Ghost?.Color}
      />
  <InputContainer
          label="BackgroundColor"
          labelField="BackgroundColor"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.StoreBranding.Ghost.BackgroundColor',
              selectedStore?.Configurations?.StoreBranding?.Ghost
            );
          }}
          type="text"
          value={selectedStore?.Configurations?.StoreBranding?.Ghost?.BackgroundColor}
      />
   <InputContainer
          label="BackgroundImage"
          labelField="BackgroundImage"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.StoreBranding.Ghost.BackgroundImage',
              selectedStore?.Configurations?.StoreBranding?.Ghost
            );
          }}
          type="text"
          value={selectedStore?.Configurations?.StoreBranding?.Ghost?.BackgroundImage}
      />
   </div>

   
}
           expandedPanel="Ghost Info"
           headerTitle="Ghost Info"
       />
<AccordionContainer
    child={
    <div onClick={() => changeImage('image')}>
<InputLabelContainer label="Logo Picture"/>
          <img
              src={selectedStore?.StoreInfo?.Configurations?.StoreLogo}
             className="w-12 h-12"
          />
            <FaCamera  className=' text-2xl text-skin-ouprimary'/>
        </div>
      }
    expandedPanel="Logo"
    headerTitle="Logo"
/>
</>
)
